import { createAdminResource } from 'lib/admin-kit';
import dealerConfig from './config';

/**
 * Registered as 'pages/admin/dealers/Edit' by react-rails via:
 *   require.context('components', true)
 *
 * Mounted from app/views/admin_kit/shared/mount.html.haml with props:
 *   record    {object}  Serialized dealer from AdminKit::DealersController#edit
 *   dealerId  {number}  Dealer id, used to scope the Sponsored By search endpoint
 */
export default createAdminResource(dealerConfig).Edit;
